import { Spin } from "antd";

export default function SiteLoader() {
  return (
    <div className="h-screen w-full flex items-center justify-center bg-violet-950">
      <div className="text-center">
        <Spin size="large" />
        <p className="text-violet-300 mt-4 text-sm">Loading Platform Admin...</p>
      </div>
    </div>
  );
}
